
import React from 'react';
import { Task } from '@/types/task';
import { useIsMobile } from '@/hooks/use-mobile';
import { MobileView } from './MobileView';
import { DesktopView } from './DesktopView';
import { useTaskNavigation } from '@/hooks/use-task-navigation';
import { getTasksByDay } from '@/utils/taskUtils';

interface TaskListWrapperProps {
  tasks: Task[];
  onComplete: (task: Task) => void;
  onDelete: (taskId: string) => void;
  onEdit: (taskId: string, data: any) => void;
  onReactivate?: (task: Task) => void;
  isAdmin: boolean;
}

export const TaskListWrapper = ({
  tasks,
  onComplete,
  onDelete,
  onEdit,
  onReactivate,
  isAdmin
}: TaskListWrapperProps) => {
  const { dateOffset, navigateDays, getCurrentDayName } = useTaskNavigation(tasks);
  const isMobile = useIsMobile();
  
  const tasksByDay = React.useMemo(() => getTasksByDay(tasks, dateOffset), [tasks, dateOffset]);
  const unscheduledTasks = React.useMemo(() => tasks.filter(task => !task.scheduledDay), [tasks]);
  const currentDayName = getCurrentDayName();

  if (!tasks) {
    return <div>Loading tasks...</div>;
  }

  return (
    <div className="w-full overflow-hidden">
      <div className="flex flex-col gap-4">
        {isMobile ? (
          <MobileView
            dateOffset={dateOffset}
            tasksByDay={tasksByDay}
            unscheduledTasks={unscheduledTasks}
            currentDayName={currentDayName}
            onNavigate={navigateDays}
            isAdmin={isAdmin}
            onComplete={onComplete}
            onDelete={onDelete}
            onEdit={onEdit}
            onReactivate={onReactivate}
          />
        ) : (
          <DesktopView
            tasksByDay={tasksByDay}
            unscheduledTasks={unscheduledTasks}
            currentDayName={currentDayName}
            onNavigate={navigateDays}
            isAdmin={isAdmin}
            onComplete={onComplete}
            onDelete={onDelete}
            onEdit={onEdit}
            onReactivate={onReactivate}
          />
        )}
      </div>
    </div>
  );
};
